import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import meetingApi from '@/services/meeting';
import MeetingDetail from '@/components/meeting/MeetingDetail.vue';
export default {
  name: 'TaskManagement',
  components: {
    MeetingDetail: MeetingDetail
  },
  data: function data() {
    var _this = this;
    return {
      searchForm: {
        taskId: '',
        processInstanceId: '',
        meetingName: '',
        handleTime: null,
        status: ''
      },
      taskList: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        onShowSizeChange: function onShowSizeChange(current, pageSize) {
          _this.pagination.pageSize = pageSize;
          _this.search();
        },
        onChange: function onChange(current) {
          _this.pagination.current = current;
          _this.search();
        }
      },
      detailVisible: false,
      selectedReservationId: null
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    search: function search() {
      var _this2 = this;
      this.loading = true;
      var params = {
        taskId: this.searchForm.taskId,
        processInstanceId: this.searchForm.processInstanceId,
        meetingName: this.searchForm.meetingName,
        beginTime: this.searchForm.handleTime ? this.searchForm.handleTime[0].format('YYYY-MM-DD') : null,
        endTime: this.searchForm.handleTime ? this.searchForm.handleTime[1].format('YYYY-MM-DD') : null,
        status: this.searchForm.status,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      meetingApi.queryTaskManagementList(params).then(function (res) {
        if (res.data && res.data.code === 200) {
          _this2.taskList = res.data.rows || [];
          _this2.pagination.total = res.data.total || 0;
        } else {
          _this2.taskList = [];
          _this2.pagination.total = 0;
          _this2.$message.error(res.data.message || '获取数据失败');
        }
      }).catch(function (err) {
        _this2.taskList = [];
        _this2.pagination.total = 0;
        _this2.$message.error('获取数据失败');
      }).finally(function () {
        _this2.loading = false;
      });
    },
    reset: function reset() {
      this.searchForm = {
        taskId: '',
        processInstanceId: '',
        meetingName: '',
        handleTime: null,
        status: ''
      };
      this.pagination.current = 1;
      this.search();
    },
    viewDetail: function viewDetail(record) {
      this.selectedReservationId = record.reservationId;
      this.detailVisible = true;
    },
    getStatusText: function getStatusText(status) {
      var statusMap = {
        'PENDING': '待处理',
        'IN_PROGRESS': '处理中',
        'COMPLETED': '已完成'
      };
      return statusMap[status] || status;
    },
    getStatusColor: function getStatusColor(status) {
      var colorMap = {
        'PENDING': 'orange',
        'IN_PROGRESS': 'blue',
        'COMPLETED': 'green'
      };
      return colorMap[status] || 'default';
    }
  },
  computed: {
    columns: function columns() {
      return [{
        title: '任务ID',
        dataIndex: 'taskId',
        key: 'taskId',
        width: 120,
        scopedSlots: {
          customRender: 'taskId'
        }
      }, {
        title: '申请流水',
        dataIndex: 'processInstanceId',
        key: 'processInstanceId',
        width: 220,
        scopedSlots: {
          customRender: 'processInstanceId'
        }
      }, {
        title: '会议标题',
        dataIndex: 'meetingName',
        key: 'meetingName',
        ellipsis: true
      }, {
        title: '办结状态',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        title: '办结意见',
        dataIndex: 'handleComment',
        key: 'handleComment',
        ellipsis: true,
        width: 150
      }, {
        title: '办结时间',
        dataIndex: 'completeTime',
        key: 'completeTime',
        width: 150
      }, {
        title: '办结人',
        dataIndex: 'handlerName',
        key: 'handlerName',
        width: 100
      }, {
        title: '分配时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 150
      }, {
        title: '操作',
        key: 'action',
        width: 100,
        scopedSlots: {
          customRender: 'action'
        }
      }];
    }
  }
};